class BiomeStageTabs extends HTMLElement {
  connectedCallback() {
    this._tabs    = Array.from(this.querySelectorAll('[data-tab]'));
    this._panels  = Array.from(this.querySelectorAll('[data-panel]'));
    this._images  = Array.from(this.querySelectorAll('[data-image]'));
    this._ctaLink = this.querySelector('[data-cta-link]');

    this._tabs.forEach(tab => {
      tab.addEventListener('click', () => this._activate(tab.dataset.tab));
    });
  }

  _activate(key) {
    this._tabs.forEach(tab => {
      tab.classList.toggle('smg-biome-stage__tab--active', tab.dataset.tab === key);
      tab.setAttribute('aria-selected', tab.dataset.tab === key ? 'true' : 'false');
    });

    this._panels.forEach(panel => {
      const isActive = panel.dataset.panel === key;
      panel.classList.toggle('smg-biome-stage__panel--active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this._images.forEach(img => {
      img.classList.toggle('smg-biome-stage__image-wrapper--hidden', img.dataset.image !== key);
    });

    if (this._ctaLink) {
      const activeTab = this._tabs.find(t => t.dataset.tab === key);
      const ctaUrl    = activeTab?.dataset.ctaUrl  || '#';
      const ctaLabel  = activeTab?.dataset.ctaLabel || '';
      this._ctaLink.href        = ctaUrl;
      this._ctaLink.textContent = ctaLabel;
    }
  }
}

customElements.define('biome-stage-tabs', BiomeStageTabs);
